import React, { useEffect, useState } from 'react';
import { store, useAppDispatch, useAppSelector } from '../../services/store';
import { getChildrenGroupedByNursery, getCurrentNursery, selectNurserySettingsLoading, updateCurrentChild } from 'src/shared/redux-state/src';
import { NurseryGroupStoreData } from 'src/shared/types/src';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ProfileImageView from '../commonComponents/ProfileImageView';
import CustomButton from '../commonComponents/CustomButton';

type IProps = {
    isNurseryListModal: boolean,
    toggleNurseryListModal: () => void
}

const NurseryListModal: React.FC<IProps> = ({ isNurseryListModal, toggleNurseryListModal }) => {

    const dispatch = useAppDispatch();
    const [selectedNursery, setSelectedNursery] = useState<NurseryGroupStoreData>();
    const currentNursery: NurseryGroupStoreData = useAppSelector(getCurrentNursery);
    const childrenGroupedByNursery: NurseryGroupStoreData[] = useAppSelector(getChildrenGroupedByNursery);
    const settingsLoader: boolean = useAppSelector(selectNurserySettingsLoading);

    useEffect(() => {
        if (currentNursery && Object.keys(currentNursery).length > 0) {
            setSelectedNursery(currentNursery);
        }
    }, [currentNursery, currentNursery.nurseryInstanceKey]);

    const handleNurserySelection = async () => {
        window.history.replaceState({}, '', `${window.location.pathname}`);
        if (selectedNursery && (selectedNursery.nurseryInstanceKey !== currentNursery.nurseryInstanceKey)) {
            await dispatch(updateCurrentChild({ currentChild: selectedNursery.children[0] }));
        }
        toggleNurseryListModal()
    }

    return (
        <Modal 
            isOpen={isNurseryListModal} 
            toggle={toggleNurseryListModal} 
            backdrop={true} 
            scrollable={true}
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader toggle={toggleNurseryListModal}>Select Nursery</ModalHeader>
            <ModalBody>
                <div className='nursery-child-wrap'>
                    <div className='d-flex flex-wrap mx-n-10'>
                        {childrenGroupedByNursery?.map((nursery: any) => {
                            const children = nursery.children || [];
                            return (
                                <>
                                    <div className='nursery-child-item pd-x-10 w-100 nursery-child-item-spacing'>
                                        <div className='d-flex align-items-center cursor-pointer' onClick={() => setSelectedNursery(nursery)}>
                                            <ProfileImageView
                                                imageUrl={nursery?.logo}
                                                resizeMode='contain'
                                                customContainerStyles={`avatar-size-80 ${selectedNursery?.nurseryInstanceKey === nursery.nurseryInstanceKey ? 'border-black' : ''}`}
                                                checkMark={selectedNursery?.nurseryInstanceKey === nursery.nurseryInstanceKey ? true : false}
                                            />
                                            <div className='nursery-child-List'>
                                                <div className={`fs-14 text-black ${selectedNursery?.nurseryInstanceKey === nursery.nurseryInstanceKey ? 'fw-semibold' : 'fw-normal'}`}>{nursery.name}</div>
                                                <div className='d-flex'>
                                                    {children.map((child: any, index: number) => {
                                                        return (
                                                            <div className='position-relative' style={{ left: index !== 0 ? index * -8 : 0, zIndex: children.length - index }}>
                                                                <ProfileImageView
                                                                    name={child?.name}
                                                                    imageUrl={child?.photo}
                                                                    resizeMode='cover'
                                                                    key={index}
                                                                    customContainerStyles={'border-white'}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <CustomButton text="Done" color="primary" onClick={handleNurserySelection} isLoading={settingsLoader}/>
            </ModalFooter>
        </Modal>
    );
};

export default NurseryListModal;
